module.exports = __webpack_public_path__ + "static/media/Briefcase.572c4fe5.svg";